import $ from 'jquery';
import MicroModal from 'micromodal';

MicroModal.init();

// Gallery
const $lightGallerySlider = $('.lightning-gallery-slider');
const $lightCurrentSlide = $('.lightning-gallery-current-item');

$lightGallerySlider.slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: false,
  nextArrow: $('.slide-m-next-lightning-gallery-slider'),
  prevArrow: $('.slide-m-prev-lightning-gallery-slider'),
});

$lightGallerySlider.on('setPosition', function (e, slick) {
  slick.$slides.css('height', slick.$slideTrack.height() + 'px');
});

$lightGallerySlider.on('init reInit afterChange', function (event, slick, currentSlide) {
  const current = (currentSlide ? currentSlide : 0) + 1;
  $lightCurrentSlide.text(current);
});

// Gallery Carousel
$('.lightning-gallery-open').on('click', function () {
  MicroModal.show('modal-lightning-gallery');
  setTimeout(() => {
    $lightGallerySlider.slick('setPosition');
  }, 100);
});

$('.gallery-grid-item').on('click', function() {
    let curIndex = $(this).data('index');
    $lightGallerySlider.slick('slickGoTo', curIndex - 1);
    MicroModal.show('modal-lightning-gallery');
    setTimeout(() => {
        $lightGallerySlider.slick('setPosition');
      }, 100);
})

// Model Gallery
const $modelGallerySlider = $('.ev-model-gallery-slider');

// Applies a base theme (group of classes) to the indvidual slider dots
$modelGallerySlider.on("init beforeChange", function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find("li");
    const theme = $(".slide-m-dots-ev-models-slider").data("theme");
    if (theme) {
      dots.addClass(theme);
    }
  }
});

$modelGallerySlider.slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: true,
  arrows: true,
  dots: true,
  nextArrow: $('.slide-m-next-ev-model-gallery-slider'),
  prevArrow: $('.slide-m-prev-ev-model-gallery-slider'),
  appendDots: $('.slide-m-dots-ev-models-slider'),
  responsive: [
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        // centerMode: true,
        // centerPadding: "8%",
      },
    },
  ],
});




